/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Drop_PlayerInputs */



/**
* | output |
* | --- |
* | "Drop player" |
*
* @param {Players_Drop_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_drop_player = /** @type {((inputs?: Players_Drop_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Drop_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déclarer l'abandon")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirar jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Retirar jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ritira giocatore")
	return /** @type {LocalizedString} */ ("Drop player")
});